import React, { useEffect, useState } from 'react';
import './Volunteering_description.css';
import Breadcrumb_Comp from '../../common/common_components/breadcrumb_comp/Breadcrumb_Comp';
import Light_Black_Btn from '../../common/common_btn/light_black_btn/Light_Black_Btn';
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { AllVolunteer, GetSIngleVolunteer } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";
import { decodeId, encodeId } from '../../../utils/common';

const Volunteering_description = () => {

  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const volunteer = useSelector((state) => state.common.volunteer);
  const getData = async (id) => {
    await dispatch(GetSIngleVolunteer(decodeId(id)));
  }
  useEffect(() => {
    if (id) {
      getData(id);
    }
  }, [id, dispatch]);


  const breadcrumbs = [
    { label: "EXPLORE", link: "/explore", active: false },
    { label: "Volunteering", link: "/volunteer", active: false },
    { label: volunteer?.name, link: "", active: true },
  ];


  return (
    <section className='Volunteering_description'>
      <div className='container-md'>
        <Breadcrumb_Comp data={breadcrumbs} />

        <div className='banner_div'>
          <img
            className='banner_img'
            src={`${IDS.IMG_URL}${volunteer?.image}`}
            alt={volunteer?.name}
          />
          <div className='overlayclr'></div>
          <div className='overlay_content'>
            <h2 className='bannertitle'>{volunteer?.name}</h2>
            <p className='bansubtext'>{volunteer?.subname}</p>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-11 mx-auto'>
            <div className='content_div'>
              <p className='content'>
                {volunteer?.description}
              </p>
              <div className='text-center'>
                <Light_Black_Btn
                  btnText={'Apply'}
                  onClick={() => navigate(`/volunteer-stepform/${encodeId(volunteer?.id)}`)}
                />
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Volunteering_description;
















// import React from 'react'
// import './Volunteering_description.css'
// import Breadcrumb_Comp from '../../common/common_components/breadcrumb_comp/Breadcrumb_Comp'
// import Light_Black_Btn from '../../common/common_btn/light_black_btn/Light_Black_Btn'
// import { useNavigate, useParams } from "react-router-dom";
// const Volunteering_description = () => {
// const { id } = useParams();

//     const breadcrumbs = [
//         { label: "EXPLORE", link: "/explore", active: false },
//         { label: "Volunteering", link: "/volunteer", active: false },
//         { label: "Food Distribution Volunteering", link: "", active: true, },
//     ];



//     const navigate = useNavigate();

//     return (
//         <>
//             <section className='Volunteering_description'>
//                 <div className='container-md'>
//                     <Breadcrumb_Comp data={breadcrumbs} />

//                     <div className='banner_div'>
//                         <img className='banner_img' src={process.env.PUBLIC_URL + '/assets/images/volunteer/banner.png'} alt="banner" />
//                         <div className='overlayclr'></div>
//                         <div className='overlay_content'>
//                             <h2 className='bannertitle'>Food Distribution Volunteering</h2>
//                             <p className='bansubtext'>Serve A Meal, Serve Humanity Join Our Food Seva!</p>
//                         </div>
//                     </div>

//                     <div className='row'>
//                         <div className='col-md-11 mx-auto'>
//                             <div className='content_div'>
//                                 <p className='content'>Samadhi encourages the recruitment and retention of qualified candidates for all positions. KTD prohibits discrimination against any individual on
//                                     the basis of race, religion, sex, age, national origin, physical or mental disability, sexual orientation, or because of marital, parental, or veteran status.
//                                     We strongly encourage minority group members, veterans, disabled individual's and women to apply for positions for which they are qualified and
//                                     that are of interest to them.
//                                 </p>
//                                 <div className='text-center'>
//                                     <Light_Black_Btn btnText={'Apply'} onClick={() => navigate('/volunteer-stepform')} />
//                                 </div>
//                             </div>
//                         </div>
//                     </div>


//                 </div>
//             </section>
//         </>
//     )
// }

// export default Volunteering_description